import React from 'react'
import { Button, Container, Row } from 'react-bootstrap'
import { AiOutlineRight } from 'react-icons/ai'
import { Link } from 'gatsby'
import CollectionsCard from '../../cards/CollectionsCard/CollectionsCard'
import ContentContainer from '../../content/ContentContainer/ContentContainer'
import ContentCover from '../../content/ContentCover/ContentCover'
import SectionHeading from '../../section-heading/SectionHeading'

const CollectionGrid = ({ categories, button }) => {
  const title = categories.title
  const description = categories.description
  const data = categories.data

  return (
    <ContentCover>
      <ContentContainer>
        <SectionHeading
          title={title}
          description={description}
          className='text-center'
        />
        <Row>
          {data.map((category, index) => {
            return <CollectionsCard key={index} category={category.node} />
          })}
        </Row>
        <Row>
          <p className='mt-lg-5 mt-3 text-center'>
            <Link to='/collections'>
              {' '}
              {button ? (
                <Button className={`btn-buy m-auto`} primary='true'>
                  {' '}
                  Explore All Categories
                  <span className='icon d-none d-lg-block'>
                    <AiOutlineRight />
                  </span>
                </Button>
              ) : (
                ''
              )}
            </Link>
          </p>
        </Row>
      </ContentContainer>
    </ContentCover>
  )
}

export default CollectionGrid
